/*
	MUTATIONS
*/
//------------------------------------------------------------
// SET THEME
//------------------------------------------------------------

const OPEN_DIRECTORY = (state, target) => {

	// maybe this switches based on the open command ?
    // var fileSystem = state.fileSystem.find(fileSystem => fileSystem.uid === payload.uid);

    target.open = !target.open;
}

//------------------------------------------------------------
// SELECT FILE FOLDER
//------------------------------------------------------------

const SELECT_ICON = (state, target) => {
    target.active = true;
}

//------------------------------------------------------------
// DESELECT ICONS
//------------------------------------------------------------

const DESELECT_ICONS = (state) => {
    var directory = state.children;

    for (var i = 0; i < directory.length; i++) {
    	directory[i].active = false; // turn all panels off
    }
}

//------------------------------------------------------------
// UPDATE ICON POSITION
//------------------------------------------------------------

const UPDATE_ICON_POSITION = (state, target) => {
    var obj = target.obj;
    var gridId = target.id;

    obj.gridId = gridId;

    // console.log(obj);
}

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	OPEN_DIRECTORY,
	SELECT_ICON,
	DESELECT_ICONS,
    UPDATE_ICON_POSITION
}
//===========================================
//
//===========================================